import { NextRequest, NextResponse } from "next/server";
import prisma from "@/lib/db";
import { getSession } from "@/lib/auth";

export async function GET() {
    try {
        const projects = await prisma.project.findMany({ include: { category: true }, orderBy: { createdAt: "desc" } });
        return NextResponse.json(projects);
    } catch (e) { return NextResponse.json({ error: "Erreur serveur" }, { status: 500 }); }
}

export async function POST(req: NextRequest) {
    const session = await getSession();
    if (!session) return NextResponse.json({ error: "Non autorisé" }, { status: 401 });
    try {
        const data = await req.json();
        const project = await prisma.project.create({ data });
        return NextResponse.json(project, { status: 201 });
    } catch (e) { return NextResponse.json({ error: "Erreur serveur" }, { status: 500 }); }
}
